// extracted by mini-css-extract-plugin
module.exports = {"cancelBtn":"SubmitCancelButtons_cancelBtn__3vdDS","yesBtn":"SubmitCancelButtons_yesBtn__2qwnq"};